import { render, staticRenderFns } from "./Cats.vue?vue&type=template&id=4b78a70c&scoped=true&"
import script from "./Cats.vue?vue&type=script&lang=js&"
export * from "./Cats.vue?vue&type=script&lang=js&"
import style0 from "./Cats.vue?vue&type=style&index=0&id=4b78a70c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b78a70c",
  null
  
)

export default component.exports